import React from 'react';

const MailingConsent = () => {
    return (
        <div style={{ padding: '40px', maxWidth: '800px', margin: '40px auto', background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', lineHeight: '1.6' }}>
            <h1 style={{ color: '#2d3748', fontSize: '24px', marginBottom: '20px', textAlign: 'center' }}>Согласие на получение рассылок</h1>
            
            <p>
                Я выражаю свое полное и безоговорочное согласие на получение рассылок информационного и рекламного содержания на электронную почту, мобильный телефон (SMS, телефонные звонки), а также push-уведомления (пуш-уведомления), указанные при заполнении регистрационной формы о программах, мероприятиях и других инициативах ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ЛАБОРАТОРИЯ ЦИФРОВЫХ ТЕХНОЛОГИЙ И ИННОВАЦИЙ"*
            </p>

            <p style={{ fontSize: '14px', color: '#718096', marginTop: '30px', borderTop: '1px solid #e2e8f0', paddingTop: '15px' }}>
                * Давая согласие адресат признает и соглашается с тем, что при прекращении оснований для направления адресату сообщений рекламного характера ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ЛАБОРАТОРИЯ ЦИФРОВЫХ ТЕХНОЛОГИЙ И ИННОВАЦИЙ" требуется до 5 (Пяти) рабочих дней для исключения адресата из списка адресатов сообщений рекламного характера в силу технических особенностей работы информационной системы. Прекращение направления сообщений рекламного характера адресату в указанный срок считается немедленным по смыслу требований законодательства Российской Федерации. Направление адресату сообщений рекламного характера до истечения срока исключения из списка адресатов рекламного характера не рассматривается как нарушение прав адресата.
            </p>

            <div style={{ marginTop: '30px', textAlign: 'center' }}>
                <button 
                    onClick={() => window.history.back()}
                    style={{ padding: '10px 20px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                    Назад
                </button>
            </div>
        </div>
    );
};

export default MailingConsent;
